import { useT } from "@transifex/react";
import moment from "moment";
import { getDateFromMilliseconds } from "../../../helpers/DateTime";
import type { ClassMember } from "../../../networking/schoolClasses";
import { toEpochMs } from "../../../utils/dateUtils";

interface ClassMemberJoinedLabelProps {
    classMember: Pick<ClassMember, "createdDate">;
    isEmphasized?: boolean;
}

const ClassMemberJoinedLabel = (props: ClassMemberJoinedLabelProps) => {
    const t = useT();
    const t_joinedToday = t("joined today", { _tags: "SchoolClasses, ClassMemberJoinedLabel" });
    const t_joinedOn = (date: string) => t("joined {date}", { _tags: "SchoolClasses, ClassMemberJoinedLabel", date });

    const created = toEpochMs(props.classMember.createdDate);
    if (created === null) return null;
    const isToday = moment(created).isSame(moment(), "day");

    return (
        <span
            data-testid="class-member-joined"
            className={`text-m shrink-0 ${
                props.isEmphasized ? "font-semibold text-p6-orange-darker" : "text-p6-grey-mid"
            }`}
        >
            {isToday ? t_joinedToday : t_joinedOn(getDateFromMilliseconds(created))}
        </span>
    );
};

export default ClassMemberJoinedLabel;
